<div class="section-form-root" [formGroup]="form">
  <div class="col-lg-6 input-panel">
    <div class="input-label">{{ 'signUp.identificationType' | translate }}*</div>
    <div class="input-field">
      <mat-select
        [placeholder]="'common.selectPlaceholder' | translate"
        class="form-control"
        formControlName="userIdentityNoType"
        (selectionChange)="changeIdentificationType()"
      >
        <mat-option *ngFor="let type of IdentificationType | enumToArray" [value]="type.key">
          {{ 'signUp.' + type.value | translate }}
        </mat-option>
      </mat-select>
      <app-validation-error-message
        [inputName]="'signUp.identificationType' | translate"
        [showFormError]="showFormError"
        [control]="form.get('userIdentityNoType')"
      >
      </app-validation-error-message>
    </div>
  </div>
  <div class="col-lg-6 input-panel">
    <div class="input-label" *ngIf="getUserIdentityNoType()">
      {{ 'signUp.' + IdentificationType[getUserIdentityNoType()] | translate }}
      {{ 'signUp.number' | translate }}*
    </div>
    <div class="input-label" *ngIf="!getUserIdentityNoType()">
      {{ 'signUp.identificationNumber' | translate }}*
    </div>
    <div class="input-field">
      <input
        class="form-control"
        *ngIf="getUserIdentityNoType() != IdentificationType.Passport"
        placeholder="{{ 'signUp.icNumberPlaceholder' | translate }}"
        formControlName="identityNo"
        [mask]="icMaskFormat"
        type="text"
      />
      <input
        class="form-control"
        *ngIf="getUserIdentityNoType() == IdentificationType.Passport"
        placeholder="{{ 'signUp.passportPlaceholder' | translate }}"
        formControlName="identityNo"
        type="text"
        alphanumeric
      />
      <app-validation-error-message
        [inputName]="'forms.profileDetails.identityNo' | translate"
        [showFormError]="showFormError"
        [control]="form.get('identityNo')"
      >
      </app-validation-error-message>
      <div
        class="error"
        *ngIf="
          showFormError &&
          form.controls.identityNo.errors &&
          (form.controls.identityNo.errors.pattern || form.controls.identityNo.errors.mask)
        "
      >
        {{ 'signUp.' + IdentificationType[getUserIdentityNoType()] | translate }}
        {{ 'signUp.number' | translate }}
        {{ 'signUp.incorrectFormat' | translate }}
      </div>
    </div>
  </div>
  <!-- INC-259: provisional copy, pending compliance/design pass -->
  <div class="col-lg-12 input-panel" *ngIf="profile?.ekycStatus == EkycStatus.Verified">
    <div class="text-muted small">
      {{ 'profile.identityChangeReKycHint' | translate }}
    </div>
  </div>
  <div class="col-lg-6 input-panel">
    <div class="input-label" *ngIf="getUserIdentityNoType()">
      {{ 'signUp.fullNameAsPer' | translate }}
      {{ 'signUp.' + IdentificationType[getUserIdentityNoType()] | translate }}*
    </div>
    <div class="input-label" *ngIf="!getUserIdentityNoType()">
      {{ 'common.fullName' | translate }}*
    </div>
    <input
      type="text"
      class="form-control"
      placeholder="{{ 'signUp.fullNamePlaceholder' | translate }}"
      formControlName="fullName"
      maxlength="100"
    />
    <app-validation-error-message
      [inputName]="'common.fullName' | translate"
      [showFormError]="showFormError"
      [control]="form.get('fullName')"
    >
    </app-validation-error-message>
  </div>
  <div class="col-lg-6 input-panel" *ngIf="role !== Role.CompanyRep">
    <div class="input-label">{{ 'profile.dateOfBirth' | translate }}*</div>
    <div class="input-field date-input" (click)="birthday.open()">
      <input
        class="form-control !tw-bg-white"
        [matDatepicker]="birthday"
        formControlName="birthday"
        name="birthday"
        placeholder="DD/MM/YYYY"
        [min]="minDob"
        [max]="today"
        readonly
      />
      <mat-datepicker-toggle matSuffix [for]="birthday" disableRipple>
        <div class="pitchin-icon pitchin-icon-calendar" matDatepickerToggleIcon></div>
      </mat-datepicker-toggle>
      <mat-datepicker #birthday></mat-datepicker>
    </div>
    <app-validation-error-message
      [inputName]="'profile.dateOfBirth' | translate"
      [showFormError]="showFormError"
      [control]="form.get('birthday')"
    >
    </app-validation-error-message>
  </div>
  <div class="col-lg-6"></div>
</div>
